import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import { useAuthStore } from '@/stores/auth'
import use446Service from '@/composables/visible/use446Service'
import use561Service from '@/composables/visible/use561Service'
import use212Service from '@/composables/visible/use212Service'
import use495Service from '@/composables/visible/use495Service'
import use124Service from '@/composables/visible/use124Service'
import use585Service from '@/composables/visible/use585Service'
import use873Service from '@/composables/visible/use873Service'
import use839Service from '@/composables/visible/use839Service'
import use663Service from '@/composables/visible/use663Service'
import use693Service from '@/composables/visible/use693Service'
import use719Service from '@/composables/visible/use719Service'
import use713Service from '@/composables/visible/use713Service'
import use714Service from '@/composables/visible/use714Service'
import use148Service from '@/composables/visible/use148Service'
import use375Service from '@/composables/visible/use375Service'
import use376Service from '@/composables/visible/use376Service'
import use838Service from '@/composables/visible/use838Service'
import use79Service from '@/composables/visible/use79Service'
import useAddressesFromComponentDeliveryDetailsService from '@/composables/visible/useAddressesFromComponentDeliveryDetailsService.js'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'

const transformRefAndValue = (rule, sourceObj) => {
  if (rule.other_ref) {
    return handleOperator(rule.operator, sourceObj[rule.ref], sourceObj[rule.other_ref])
  } else {
    return handleOperator(rule.operator, sourceObj[rule.ref], rule.value)
  }
}

const handleOperator = (operator, sourceValue, otherValue) => {
  switch (operator) {
    case 'hasValue':
      return !!sourceValue == otherValue
    case 'equal':
      return sourceValue == otherValue
    case 'notEqual':
      return sourceValue != otherValue
    case 'greaterThan':
      return sourceValue > otherValue
    case 'lessThan':
      return sourceValue < otherValue
    case 'greaterThanInclusive':
      return sourceValue >= otherValue
    case 'lessThanInclusive':
      return sourceValue <= otherValue
    case 'in':
      return otherValue.includes(sourceValue)
    case 'notIn':
      return !otherValue.includes(sourceValue)
    case 'contains':
      return sourceValue && sourceValue.includes(otherValue)
    case 'notContains':
      return !sourceValue.includes(otherValue)
    case 'isNotNull':
      return !!sourceValue
    default:
      return false
  }
}

const findShowRule = (currentRules, ruleType, sourceObj) => {
  if (!sourceObj) {
    throw new Error('sourceObj should not be undefined. Configure getBindObj first.')
  }

  const res = currentRules.map((rule) => {
    if (rule?.any || rule?.all) {
      return findShowRule(rule?.any || rule?.all, rule?.any ? 'any' : 'all', sourceObj)
    } else {
      return transformRefAndValue(rule, sourceObj)
    }
  })
  const oneLogicalOperatorResultStr = res.join(ruleType === 'any' ? ' || ' : ' && ')
  return eval(oneLogicalOperatorResultStr)
}
// For typing-center services,that not conflict with other services
const commonTypingCenter = (serviceId) => {
  const authStore = useAuthStore()
  return {
    isUserTypingCenter: authStore.isUserTypingCenter
  }
}

const getPreBindObj = (serviceId) => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const authStore = useAuthStore()
  const { applicationId } = authStore.user
  const form = formStore.form?.values || {}
  const extraMap = formStore.extraMap || {}
  const startedService = globalStore.startedService || {}
  const {
    application: { resident, establishment },
    relationships: { daughter, son, wife, husband, father, mother },
    educationLevels: { none, belowEducationAge, diploma, highDiploma, bachelor, master, doctoral },
    uaeNationality,
    workTypes: { Private, government },
    mainDepartments: { dubai },
    talentedPeopleNotRequireWorkplace
  } = lookups
  const { optionalNominationRequestForTransactionReasons } = client_config

  switch (+serviceId) {
    case 109:
    case 114:
    case 115:
    case 119:
      return {
        selectIdentificater: form.selectIdentificater,
        relationsShipId:
          form?.edit_requestNaturalizationForChildsFamily?.parentInfo?.relationsShipId,
        status: form?.edit_requestNaturalizationForChildsFamily?.parentInfo?.status,
        iHaveRelativesInHomeland: form.iHaveRelativesInHomeland
      }
    case 139:
    case 140:
    case 141:
    case 160:
      return {
        isUsingCardReader: form.isUsingCardReader,
        initialApprovalType: form.initialApprovalType,
        serviceTransactionId: startedService.serviceTransactionId,
        hideInvestorInfo: startedService.serviceConfig.hideInvestorInfo
      }
    case 184:
    case 185:
    case 200:
    case 201:
    case 202:
    case 203:
    case 409:
    case 410:
      return {
        isUsingCardReader: form.isUsingCardReader,
        showResidenceDate: form.fileModuleId == 1,
        isSponsorIdentityNumber: false,
        serviceTransactionId: startedService.serviceTransactionId
      }
    case 424:
    case 1057:
    case 79:
      return use79Service()
    case 124:
      return use124Service()
    case 148:
      return use148Service()
    case 187:
      return {
        serviceTransactionId: startedService.serviceTransactionId,
        identificater: form?.identificater,
        humanExceptionRequestTypeId: form?.humanExceptionRequestTypeId,
        entryPermitMSG: extraMap.entryPermitMSG,
        issuingResidencyMSG: extraMap.issuingResidencyMSG,
        renewResidenceMSG: extraMap.renewResidenceMSG,
        humanExceptionStatusId: form.humanExceptionStatusId,
        disableHumanException: extraMap.disableHumanException
      }
    case 206:
    case 207:
    case 208:
    case 209:
      return {
        hideSponsorSection: form.hideSponsorSection,
        showQuestionnaires: extraMap.showQuestionnaires,
        showQuestionnaireQuestionThree: extraMap.showQuestionnaireQuestionThree
      }
    case 212:
      return use212Service()

    case 446:
    case 447:
    case 607:
      return use446Service()
    case 495:
      return use495Service()

    case 401:
      return {
        transactionReasonIds: form?.transactionReasonIds
      }
    case 407:
    case 784:
      return {
        configMode: startedService.serviceConfig.mode,
        isInCompleteDraftFlag: formStore?.draft?.isIncompleteDraft,
        isNewBorn: startedService.serviceConfig.mode == 'newBorn',
        fileType: form?.fileType,
        showForm: extraMap.showForm,
        userExist: extraMap.userExist,
        selectIdentificater: form?.selectIdentificater,
        applicationId: authStore.user.applicationId,
        serviceTransactionId: startedService.serviceTransactionId
      }
    case 432:
    case 783:
    case 939:
    case 941:
    case 942:
    case 944:
    case 945:
    case 946:
      return {
        educationLevelId: form?.educationLevelId,
        isFaithRequired: extraMap.isFaithRequired,
        selectIdentificater: form?.selectIdentificater,
        isReadDataFromCard: extraMap.isReadDataFromCard,
        hideRetriveVisaInfoSection: extraMap.hideRetriveVisaInfoSection,
        retriveVisaInfo: form?.retriveVisaInfo,
        isOpenRetriveVisaInfoSection: extraMap.isOpenRetriveVisaInfoSection,
        showAllSection: false,
        showAllSectionOnResponse: false,
        transactionReason: extraMap.transactionReason,
        serviceTransactionId: startedService.serviceTransactionId,
        showEstablishmentDetails: extraMap.showEstablishmentDetails,
        workPlaceEstablishmentDepartmentId: form?.workPlaceEstablishmentDepartmentId !== 8,
        isReasonRequiresThreeSectionEstabNumber: extraMap.isReasonRequiresThreeSectionEstabNumber,
        applyVisaByNominationRequest: form?.applyVisaByNominationRequest,
        enableNominationRequest: extraMap.enableNominationRequest,
        hideNominationInfoForSelectedReason: extraMap.hideNominationInfoForSelectedReason,
        showOptionalNominationRequestForServices: extraMap.showOptionalNominationRequestForServices,
        showApplyByNomination: extraMap.showApplyByNomination,
        enableAnonymousUsersToRetrieveTheirVisaInfo:
          extraMap.enableAnonymousUsersToRetrieveTheirVisaInfo,
        hidereCAPTCHA: extraMap.hidereCAPTCHA,
        showConductIdentificationCodeCertificate: extraMap.showConductIdentificationCodeCertificate,
        showUniversities: extraMap.showUniversities
      }
    case 767:
      return {
        __isLoggedIn__: [resident, establishment].includes(applicationId),
        isInCompleteDraftFlag: formStore?.draft?.isIncompleteDraft,
        nominationIdentificater: form?.nominationIdentificater,
        transactionReasonCategoryId: form?.transactionReasonCategoryId,
        transactionReasonId: form?.transactionReasonId
      }

    case 675:
      return {
        isTypingCenter: authStore.isUserTypingCenter
      }
    case 502:
    case 503:
    case 556:
    case 900:
      return {
        hideIdentificationInformation: extraMap.hideIdentificationInformation,
        enableIdentificationInformation: extraMap.enableIdentificationInformation,
        isVisaFileNumberRequired: extraMap.isVisaFileNumberRequired,
        isNumberOfYearsDisabled: extraMap.isNumberOfYearsDisabled,
        countryOfBirthId: form?.countryOfBirthId == uaeNationality,
        qualificationLevelId: form?.qualificationLevelId,
        workTypeId: form?.workTypeId,
        showFatherInformation:
          [daughter, son].includes(form.sponsorRelationshipId) &&
          form?.individualInfo?.genderId == 2,
        showMotherInformation:
          [daughter, son].includes(form.sponsorRelationshipId) &&
          form?.individualInfo?.genderId == 1,
        showidentityNumberField: !!form.showidentityNumberField,
        isParentInsideUae: form?.isParentInsideUae,
        serviceTransactionId: extraMap.serviceTransactionId,
        deliveryCompanyId: form?.deliveryCompanyId,
        deliveryMethodId: form?.deliveryMethodId,
        urgentServiceFlag: !!form?.urgentServiceFlag,
        havePoBox: form?.havePoBox
      }
    case 571:
    case 572:
    case 580:
      return {
        isUserServiceCenter: authStore.isUserServiceCenter,
        isUserEstablishment: authStore.isUserEstablishment,
        isUserTypingCenter: authStore.isUserTypingCenter,
        showCurrentMobileNumber: extraMap.showCurrentMobileNumber,
        educationLevelId: form?.educationLevelId,
        deliveryCompanyId: form?.deliveryCompanyId,
        deliveryMethodId: form?.deliveryMethodId,
        urgentServiceFlag: !!form?.urgentServiceFlag,
        havePoBox: form?.havePoBox,
        preferedLanguageId: form?.preferedLanguageId,
        countryOfBirthId: form?.countryOfBirthId,
        ageGreaterThan15: !!extraMap.ageGreaterThan15,
        showCompanyName: [Private].includes(form?.workTypeId),
        showGovernmentalDepartment: [government].includes(form?.workTypeId)
      }

    case 561:
      return use561Service()
    case 585:
      return use585Service()
    case 663:
      return use663Service()
    case 693:
      return use693Service()
    case 713:
      return use713Service()
    case 714:
      return use714Service()
    case 719:
      return use719Service()
    case 962:
      return {
        isFaithRequired: extraMap.isFaithRequired ?? true,
        selectIdentificater: form?.selectIdentificater,
        educationLevelId: form?.educationLevelId
      }
    case 375:
      return use375Service()
    case 376:
      return use376Service()
    case 1040:
      return {
        __isLoggedIn__: [resident].includes(applicationId),
        isPersonExempted: form?.isPersonExempted
      }
    case 1090:
      return {
        selectIdentificater: form?.selectIdentificater,
        identificater: form?.identificater,
        transactionReasonId: form?.transactionReasonId
      }
    case 838:
      return use838Service()
    case 839:
      return use839Service()
    case 873:
      return use873Service()
    case 920:
    case 573:
    case 574:
    case 575:
      return {
        gccClassCode: form.gccClassCode,
        gccCategoryCode: form.gccCategoryCode,
        gccTypeCode: form.gccTypeCode,
        educationLevelId: form?.educationLevelId,
        workTypeId: form?.workTypeId,
        showGccCategoryCodeList: extraMap.showGccCategoryCodeList,
        showQualificationLevel: extraMap.showQualificationLevel,
        showWorkType: extraMap.showWorkType,
        showChangePersonPhoto: extraMap.showChangePersonPhoto,
        enableRenew: extraMap.enableRenew,
        serviceTransactionId: startedService.serviceTransactionId,
        countryOfBirthId: form?.countryOfBirthId == uaeNationality
      }
    case 922:
      return {
        educationLevelId: form?.educationLevelId
      }

    case 761:
      return {
        identifierType: form?.edit_relativesInformation?.identifierType
      }
    case 914:
      return {
        selectedIdentifier: form?.selectedIdentifier
      }
    case 588:
      return {
        identificationType: form?.identificationType
      }
    case 37:
    case 995:
      return {
        countryOfBirthId: form?.countryOfBirthId,
        showExceptions: ![daughter, son, wife, husband, father, mother].includes(
          form.familyRelationshipId
        ),
        showFatherInformation:
          [daughter, son].includes(form.familyRelationshipId) && form.individualInfo.genderId == 2,
        showMotherInformation:
          [daughter, son].includes(form.familyRelationshipId) && form.individualInfo.genderId == 1,
        loadCanceledSponsored: form?.loadCanceledSponsored,
        isParentInsideUae: form.isParentInsideUae,
        selectIdentificater: form.selectIdentificater,
        showSponsorFileWarningMessage: formStore.extraMap.showSponsorFileWarningMessage || false,
        showHostSponsorFileWarningMessage:
          formStore.extraMap.showHostSponsorFileWarningMessage || false,
        sponsoredEntryStatus: form.sponsoredEntryStatus || 2,
        visaDuarationMsg: extraMap.visaDuarationMsg
      }
    case 413:
    case 632:
    case 633:
    case 635:
    case 636:
    case 753:
    case 639:
    case 1104:
    case 1105:
      return {
        workPlaceEstablishmentDepartmentId: form.workPlaceEstablishmentDepartmentId,
        serviceTransactionId: startedService.serviceTransactionId,
        showApplyByNomination: extraMap.showApplyByNomination,
        showHostSponsorFileWarningMessage:
          formStore.extraMap.showHostSponsorFileWarningMessage || false,
        showSponsorFileWarningMessage: formStore.extraMap.showSponsorFileWarningMessage || false,
        showEstablishmentDetails: !talentedPeopleNotRequireWorkplace.includes(
          form.transactionReasonId
        ),
        isLongTermVisaForMainPerson: !!startedService.isLongTermVisaForMainPerson,
        workPlaceEstablishmentDepartmentId: form?.workPlaceEstablishmentDepartmentId,
        isReasonRequiresThreeSectionEstabNumber: form?.workPlaceEstablishmentDepartmentId == dubai,
        transactionReasonId: optionalNominationRequestForTransactionReasons.includes(
          form?.transactionReasonId
        ),
        applyVisaByNominationRequest: form?.applyVisaByNominationRequest
      }

    case 582:
    case 583:
    case 587:
      return {
        motherRegisteredAtFamilyBook: form?.motherRegisteredAtFamilyBook,
        birthPlace: form?.birthPlace,
        motherNationalityId: form?.motherNationalityId
      }
    case 593:
      return {
        placeOfDeath: form?.placeOfDeath
      }
    case 596:
      return {
        divorceCountry: form?.divorceCountry
      }
    case 730:
      return {
        transactionReasonId: form?.transactionReasonId
      }
    case 4:
    case 8:
    case 10:
    case 15:
    case 17:
    case 25:
    case 46:
    case 47:
    case 48:
    case 49:
    case 29:
    case 33:
    case 34:
    case 42:
    case 142:
    case 149:
    case 156:
    case 157:
    case 158:
    case 160:
    case 162:
    case 343:
    case 344:
    case 345:
    case 363:
    case 364:
    case 365:
    case 380:
    case 453:
    case 458:
    case 459:
    case 463:
    case 477:
    case 482:
    case 483:
    case 518:
    case 637:
    case 651:
    case 652:
    case 653:
    case 654:
    case 655:
    case 727:
    case 744:
    case 745:
    case 748:
    case 749:
    case 750:
    case 837:
    case 919:
    case 927:
    case 936:
    case 949:
    case 960:
    case 961:
    case 1049:
    case 1052:
    case 1120:
    case 1021:
    case 1059:
      return {
        serviceTransactionId: startedService.serviceTransactionId,
        countryOfBirthId: form?.countryOfBirthId,
        educationLevelId: form?.educationLevelId,
        qualificationLevelId: form?.qualificationLevelId,
        urgentServiceFlag: !!formStore.extraMap?.urgentServiceFlag,
        deliveryCompanyId: form?.deliveryCompanyId,
        deliveryMethodId: form?.deliveryMethodId,
        showMobileNumbersListForTawzee: formStore.extraMap.showMobileNumbersListForTawzee,
        selectIdentificater: form.selectIdentificater,
        showSponsorFileWarningMessage: formStore.extraMap.showSponsorFileWarningMessage || false,
        showHostSponsorFileWarningMessage:
          formStore.extraMap.showHostSponsorFileWarningMessage || false,
        sponsoredEntryStatus: form.sponsoredEntryStatus || 2,
        isUsingCardReader: form.isUsingCardReader,
        notRequiredSponsorEIDA: extraMap.notRequiredSponsorEIDA,
        hideSponsorInformation: extraMap.hideSponsorInformation
      }
    case 418:
      return {
        hideSponsorInformation: extraMap.hideSponsorInformation
      }
    case 870: {
      const { requireEnrollmentInd } = formStore.draft.request
      const requiresFingerprintAppointment = !requireEnrollmentInd && !authStore.isGuestUser

      return {
        serviceTransactionId: startedService.serviceTransactionId,
        countryOfBirthId: form?.countryOfBirthId,
        educationLevelId: form?.educationLevelId,
        qualificationLevelId: form?.qualificationLevelId,
        urgentServiceFlag: !!formStore.extraMap?.urgentServiceFlag,
        deliveryCompanyId: form?.deliveryCompanyId,
        deliveryMethodId: form?.deliveryMethodId,
        showMobileNumbersListForTawzee: formStore.extraMap.showMobileNumbersListForTawzee,
        requiresAppointment: requiresFingerprintAppointment
      }
    }
    case 393:
      return {
        insurancePolicyTypeId: form?.insurancePolicyTypeId,
        serviceTransactionId: startedService.serviceTransactionId
      }
    case 739:
      return {
        isUsingCardReader: form.isUsingCardReader,
        showQuestionnaires: form?.totalViolationAmount >= 1000,
        showQuestionnaireQuestionThree: extraMap.showQuestionnaireQuestionThree
      }
    case 903:
      return {
        identifierType: form?.edit_relativesInformation?.identifierType
      }

    case 460:
    case 461:
      return {
        refundMethodId: form['refundMethodId.id']
      }
    case 461:
      return {
        refundMethodId: form['refundMethod.id']
      }
    case 917:
      return {
        countryOfBirthId: form.countryOfBirthId,
        qualificationLevelId: form.qualificationLevelId,
        educationLevelCountryId: form.educationLevelCountryId,
        preferedLanguageId: form.preferedLanguageId
      }
    case 617:
      return {
        personUnifiedNumber: form.preferedLanguageId
      }
    case 481:
      return {
        showShipsTable: formStore.extraMap.showShipsTable,
        isInboundTrip: form.tripClassId === 1
      }
    case 24:
    case 26:
    case 27:
    case 28:
    case 36:
    case 38:
    case 40:
    case 43:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 383:
    case 385:
    case 386:
    case 387:
    case 414:
    case 420:
    case 436:
    case 490:
    case 642:
    case 644:
    case 645:
    case 646:
    case 647:
    case 648:
    case 664:
    case 666:
    case 678:
    case 755:
    case 757:
    case 764:
    case 785:
    case 926:
    case 928:
    case 933:
    case 950:
    case 951:
    case 952:
    case 963:
    case 964:
    case 965:
    case 973:
    case 976:
    case 977:
    case 978:
    case 994:
    case 1005:
    case 1006:
    case 1007:
    case 1008:
    case 1009:
    case 1010:
    case 1041:
    case 1092:
    case 1099:
    case 1118:

    case 57:
    case 58:
    case 59:
    case 89:
    case 120:
    case 121:
    case 122:
    case 567:
    case 400:
    case 437:
    case 438:
    case 569:
    case 641:
    case 656:
    case 657:
    case 658:
    case 659:
    case 662:
    case 665:
    case 667:
    case 668:
    case 679:
    case 680:
    case 756:
    case 758:
    case 759:
    case 763:
    case 771:
    case 773:
    case 774:
    case 775:
    case 776:
    case 777:
    case 778:
    case 916:
    case 935:
    case 938:
    case 943:
    case 981:
    case 982:
    case 987:
    case 985:
    case 989:
    case 993:
    case 991:
    case 1018:
    case 1023:
    case 1026:
    case 1031:
    case 1033:
    case 1035:
    case 1042:
    case 1062:
    case 1093:
    case 1095:
    case 1100:
    case 1102:
    case 1108:
    case 1110:
    case 1123:
    case 1125:
    case 1127:

    case 69:
    case 70:
    case 71:
    case 423:
    case 676:
    case 677:
    case 681:
    case 685:
    case 686:
    case 687:
    case 688:
    case 689:
    case 690:
    case 760:
    case 769:
    case 820:
    case 948:
    case 955:
    case 959:
    case 980:
    case 1044:
    case 1055:
    case 1106:
    case 1097:
    case 1116:

    case 421:
    case 429:
    case 515:
    case 599:
    case 600:
    case 601:
    case 602:
    case 613:
    case 754:
    case 768:
    case 931:
    case 979:
    case 983:
    case 1038:
    case 1112:
    case 1113:

    case 640:

    case 765:

    case 92:
    case 406:
    case 443:
    case 445:
      return {
        isReadDataFromCard:
          extraMap.isReadDataFromCard ?? (authStore.isUserTypingCenter ? true : false),
        hideSponsorInformation: extraMap.hideSponsorInformation,
        transactionReason: startedService.serviceConfig.transactionReason,
        isFaithRequired: extraMap.isFaithRequired ?? true,
        isResidencyFileNumberRequired: startedService.serviceConfig.isResidencyFileNumberRequired,
        changeStatus: startedService.serviceConfig.changeStatus,
        usingFileNumberOnly: startedService.serviceConfig.usingFileNumberOnly,
        isVisaFileNumberRequired: startedService.serviceConfig.isVisaFileNumberRequired,

        activeStepIndex: formStore.activeStepIndex,
        isEIDAholderSponsor: extraMap.isEIDAholderSponsor,
        isUsingSponsorEIDA: extraMap.isUsingSponsorEIDA,
        showExceptions: !!form.sponsorRelationshipId,
        showMsg: ![daughter].includes(form.sponsorRelationshipId),
        showEducationLevelCountry:
          form.educationLevelId && ![none, belowEducationAge].includes(form.educationLevelId),
        showQualificationDescription: [diploma, highDiploma, bachelor, master, doctoral].includes(
          form.educationLevelId
        ),
        withSponsor: form.withSponsor,
        isNewPassport: form.isNewPassport,
        isNewResidency: false,
        educationLevelId: form.educationLevelId,
        showWithSponsor: form.showWithSponsor,
        hideSponsorInformation: extraMap.hideSponsorInformation,
        isOutsideUAE: form?.isOutsideUAE == 2,
        showFreeDeposit: startedService.showFreeDeposit,
        loadCanceledSponsored: form?.loadCanceledSponsored,
        __isLoggedIn__: !authStore.isGuestUser,
        applyVisaByNominationRequest: form.applyVisaByNominationRequest,
        sponsorRelationshipId: form.sponsorRelationshipId,
        showEstablishmentDetails: extraMap.showEstablishmentDetails,
        isParentInsideUae: form.isParentInsideUae,
        showMotherInformation: extraMap.showMotherInformation,
        showFatherInformation: extraMap.showFatherInformation,
        preferedLanguageId: form.preferedLanguageId,
        selectIdentificater: form.selectIdentificater,
        showSponsorFileWarningMessage: formStore.extraMap.showSponsorFileWarningMessage || false,
        showHostSponsorFileWarningMessage:
          formStore.extraMap.showHostSponsorFileWarningMessage || false,
        sponsoredEntryStatus: form.sponsoredEntryStatus || 2,
        isSponsoredSonAbove25Case: formStore.draft?.isSponsoredSonAbove25Case ?? false,
        isUsingCardReader: false,
        isGenderDisabled: formStore.extraMap?.isGenderDisabled ?? false,
        serviceTransactionId: startedService.serviceTransactionId,
        showProffessionNote: extraMap.showProffessionNote,
        disableSponsorType: extraMap.disableSponsorType,
        showLocalAddressDetails: extraMap.showLocalAddressDetails,
        isDisableGender: extraMap.isDisableGender
      }
    case 433:
      return {
        showVisaOnArrivalWarningMessage: extraMap.showVisaOnArrivalWarningMessage,
        serviceTransactionId: startedService.serviceTransactionId
      }

    case 905:
    case 1028:
    case 1029:
    case 1030:
      return {
        isUsingCardReader: form.isUsingCardReader,
        fileModuleId: form.fileModuleId,
        disableCardReader: extraMap.disableCardReader
      }
    case 411:
      return {
        serviceTransactionId: startedService.serviceTransactionId,
        isUsingCardReader: form.isUsingCardReader
      }
    case 923:
    case 1011:
      return {
        serviceTransactionId: startedService.serviceTransactionId
      }
    case 1058:
      return {
        transactionReasonId: form.transactionReasonId,
        isUserEstablishment: authStore.isUserEstablishment
      }
    case 369:
      return {
        isUserEstablishment: authStore.isUserEstablishment
      }
    default:
      break
  }
}

/**
 * checks the form if a certain attribute is present
 * if so, add it to the result object.
 */
const applyCommonlyUsedAttributes = (obj) => {
  const formStore = useFormStore()
  const form = formStore.form?.values || {}

  return {
    ...obj,
    ...('religionId' in form && { religionId: form.religionId })
  }
}
const getBindObj = (serviceId) => {
  const obj = getPreBindObj(serviceId) || {}
  const addressesFromComponentDeliveryDetailsService =
    useAddressesFromComponentDeliveryDetailsService()
  const commonTypingCenterObj = commonTypingCenter(serviceId)

  Object.assign(obj, applyCommonlyUsedAttributes(obj))

  return {
    ...commonTypingCenterObj,
    ...addressesFromComponentDeliveryDetailsService,
    ...obj,
    serviceTransactionId: +serviceId
  }
}

export default function () {
  return {
    findShowRule,
    getBindObj
  }
}
